module.exports = __webpack_public_path__ + "media/images/noticeMobile-510444f1b0cfe2d80d3add46221a143c.svg";